import { useLocation } from "react-router-dom"
import { useGetMyJailStatusQuery } from "store/apis/jailAPI"
import { isUserInJail } from "store/apis/jailAPI/jail.helpers"

export const useMenuActiveState = () => {
  const location = useLocation()
  const { data: jailData } = useGetMyJailStatusQuery()

  const userIsInJail = isUserInJail(jailData?.data)

  const isMenuItemActive = (
    url: string,
    startUrl?: string,
    isDefaultActive?: boolean
  ): boolean => {
    if (url === "/jail" && userIsInJail) {
      return location.pathname === "/jail" || isDefaultActive || false
    }
    if (url === "/" && userIsInJail) {
      return location.pathname === "/jail" || isDefaultActive || false
    }

    return (
      isDefaultActive ||
      (startUrl ? location.pathname.startsWith(startUrl) : false)
    )
  }

  return {
    isMenuItemActive,
    userIsInJail,
    currentPath: location.pathname
  }
}
